export default class InsufficientFundError extends Error {
    constructor(message, expected, balance) {
        super(message);
        this.name = "InsufficientFundError";
        this.expectedSol = expected / 1e9;
        this.balanceSol = balance / 1e9;
    }
}
